import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Screener from './Screener';
import Analysis from './Analysis';
import axios from 'axios';
import './App.css';
import refinitivlogo from './img/refinitiv.png';
import Config from './Configs/criteria.json';
import ver from '../package.json';

class App extends Component {
  constructor(props) {
    super(props);

    var that = this;

    axios.defaults.baseURL = process.env.REACT_APP_DATA_API_DOMAIN || "/sbiscrapi";
    axios.defaults.headers.common['Pragma'] = 'no-cache';

    axios.interceptors.response.use(function (response) {
      // Do something with response data
      return response;
    }, function (error) {
      let status = error.response.status;
      if (status === 401) {
        that.setState({ warn: true });
        // window.location.href = '../';
      }
      // Do something with response error
      return Promise.reject(error);
    });
  }
  render() {
    return (
      <div className="App">
        <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ''}>
          <Switch>
            <Route path="/analysis" component={Analysis} />
            <Route path="/data/criteria" render={() => <div>{JSON.stringify(Config.criteria)}</div>} />
            {/* <Route path="/analysis" render={() => <div>analysis</div>} /> */}
            <Route path="/login" render={() => <div>login</div>} />
            <Route path="/version" render={() => <div>v{ver.version}</div>} />
            <Route path="/disclaimer" render={() => <div><div style={{ lineHeight: '20px' }}>(c) 2019 Refinitiv. All rights reserved.
              <br></br><br></br>
              Refinitiv（リフィニティブ）が事前に書面により承認した場合を除き、リフィニティブのコンテンツを再発行や再配布すること（フレーミングまたは類似の方法による場合を含む）は、明示的に禁止されています。Refinitiv（リフィニティブ）およびRefinitiv（リフィニティブ）のロゴは、リフィニティブ及びその関連会社の登録商標であり、商標となっています。リフィニティブのその他のサービスに関する詳細をお知りになりたい場合は、リフィニティブのパブリック・ウェブサイト<a href="http://www.refinitiv.com" >http://www.refinitiv.com</a>をご覧ください。<br></br><br></br>

              リフィニティブは提供する情報の正確性と信頼性を確保するよう努めますが、その正確性を保証するものではなく、不正確または不作為（不法行為または契約その他）から生じるいかなる損失または損害に対しても責任を負いません。<br></br><br></br>

              リフィニティブが提供するコンテンツ（本コンテンツ）はあくまでも個人への情報の提供を目的としたものであり、商用目的のために提供されているものではありません。また、投資活動を勧誘又は誘引するものではなく、取引又は売買を行う際の意思決定の目的で使用することは適切ではありません。本コンテンツは投資助言となる投資、税金、法律等のいかなる助言も提供せず、また、特定の金融の個別銘柄、金融投資あるいは金融商品に関するいかなる勧告もしません。本コンテンツの使用は、資格のある投資専門家の投資助言に取って代わるものではありません。本コンテンツは時間の経過により不正確となる場合があり、従ってヒストリカル情報としてのみ解釈されるべきであります。投資を検討中の利用者は、投資に関する契約を締結する前に、自ら、資格のある投資専門家に相談したうえで、投資をされるべきであります。投資行為は、その性質上、損失を帰結する場合があります。リフィニティブも第三者コンテンツ・プロバイダーも、明示又は黙示を問わず、提供された本コンテンツの正確性又は目的適合性に関する保証をすべて明示的に排除し、本コンテンツの誤謬・不正確や遅延、又はそれらに依拠してなされた行為について、何らの責任も負うものではありません。</div>
              <a className='refinitivlogo' style={{display: "flex",justifyContent: "flex-end"}}>
                <img src={refinitivlogo} width="150" alt="Refinitiv" /></a>
            </div>} />


            {/* <Route path="/main/:token/:preset" component={Screener} />
            <Route path="/main/:token" component={Screener} /> */}
            <Route path="/main" component={Screener} />
            <Route exact path="/" render={() => <div>Authorization failed</div>} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
